import React from "react";
import { withSwal } from "react-sweetalert2";

interface IConfirmAlert {
    text: string;
    textButtonConfirm?: string;
    titleSucesso?: string;
    mensagemSucesso: string;
    cb?: () => void;
    onConfirm?: (any?: any) => Promise<any>;
}

const ConfirmAlert: React.FC<IConfirmAlert> = withSwal((props: any) => {
    const { swal, children, text, cb, onConfirm, mensagemSucesso, textButtonConfirm, titleSucesso } = props;

    return (
        <div
            className="action-icon"
            id="sa-warning"
            onClick={() =>
                swal
                    .fire({
                        title: "Você tem certeza?",
                        text: text,
                        icon: "warning",
                        showCancelButton: true,
                        cancelButtonColor: "#236BB0",
                        confirmButtonColor: "#f34e4e",
                        confirmButtonText: textButtonConfirm ?? "Excluir",
                        cancelButtonText: "Cancelar"
                    })
                    .then(async function (result: { value: any }) {
                        try {
                            if (result.value) {
                                if(onConfirm) {
                                    await onConfirm();
                                } else {
                                    await cb();
                                }
                                swal.fire(
                                    titleSucesso ?? "Deletado",
                                    mensagemSucesso,
                                    "success"
                                );
                            }
                        } catch (error: any) {
                            swal.fire(
                                "Ops!",
                                error.response?.data?.error,
                                "error"
                            );
                        }
                    })
            }
        >
            {children}
        </div>
    );
});

export default ConfirmAlert;
